import { BreakpointsOptions } from '@mui/material';

export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 1280,
    md: 1440,
    lg: 1728,
    xl: 1920,
  },
};
